
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";

interface Testimonial {
  quote: string;
  author: string;
  company: string;
}

const TestimonialSection: React.FC = () => {
  const testimonials: Testimonial[] = [
    {
      quote: "Noord AI heeft ons geholpen om onze klantenservice te verbeteren met een slimme chatbot. Het resultaat is indrukwekkend!",
      author: "Martijn de Vries",
      company: "Groningen Marketing"
    },
    {
      quote: "Dankzij Noord AI begrijp ik eindelijk wat AI voor mijn bedrijf kan betekenen, zonder al die technische termen.",
      author: "Lisa Bakker",
      company: "Bakker Verzekeringen"
    },
    {
      quote: "De workshop die Noord AI voor ons team heeft gegeven was precies wat we nodig hadden om AI in ons dagelijks werk te integreren.",
      author: "Peter Jansen",
      company: "Noord Vastgoed"
    }
  ];

  return (
    <section className="py-16 px-6 bg-gray-50">
      <div className="container mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Wat zeggen klanten over ons?</h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="h-full shadow-sm border-none bg-white hover:shadow-md transition-shadow">
              <CardContent className="p-8">
                <div className="mb-6 text-noordblue">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="currentColor" stroke="none">
                    <path d="M11.9995 21C13.9768 21 15.9029 20.4718 17.5569 19.4817C19.2108 18.4916 20.5211 17.0798 21.3442 15.4149C22.1673 13.7499 22.4681 11.8942 22.2088 10.0788C21.9496 8.26345 21.142 6.57029 19.8996 5.22183C18.6572 3.87336 17.0279 2.9442 15.2387 2.56161C13.4495 2.17901 11.5883 2.36074 9.89839 3.08358C8.20847 3.80642 6.76623 5.03804 5.72943 6.60718C4.69263 8.17632 4.10669 10.019 4.04382 11.9227C3.98094 13.8264 4.44302 15.7063 5.37451 17.3323C6.3393 18.9984 7.5489 20.1752 8.99947 21H11.9995Z" opacity="0.2"></path>
                    <path d="M14.017 18.152a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0 0a7.997 7.997 0 0 1-6.536-3.383M9.5 8.5c.5-1 1.5-1.5 2.5-1.5 1.5 0 2.5 1.5 2.5 2.5M14 14.5c-.5.5-2.5.5-3 0"></path>
                  </svg>
                </div>
                <p className="text-gray-600 italic mb-6">{testimonial.quote}</p>
                <div>
                  <p className="font-semibold text-gray-800">{testimonial.author}</p>
                  <p className="text-gray-500 text-sm">{testimonial.company}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
